import { useState } from "react";
import { toast } from "sonner";
import { RotateCcw, Lock } from "lucide-react";
import { Layout } from "../components/Layout";
import { PacksShop, NewsletterForm, ContactForm } from "../components/ParentSections";
import { useStars } from "../lib/stars";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../components/ui/alert-dialog";
import { t } from "../i18n";

const rand = (a, b) => a + Math.floor(Math.random() * (b - a + 1));

const Gate = ({ onPass }) => {
  const [q, setQ] = useState(() => ({ a: rand(6, 19), b: rand(4, 9) }));
  const [value, setValue] = useState("");
  const submit = (e) => {
    e.preventDefault();
    if (Number(value) === q.a + q.b) return onPass();
    toast.error(t("parents.wrong"));
    setQ({ a: rand(6, 19), b: rand(4, 9) });
    setValue("");
  };
  return (
    <form onSubmit={submit} className="cloud-card puffs mx-auto mt-10 max-w-md p-8" data-testid="parent-gate">
      <h2 className="flex items-center gap-2 text-2xl font-extrabold"><Lock className="w-6 h-6" /> {t("parents.gateTitle")}</h2>
      <p className="mt-2 text-base opacity-80">{t("parents.gateHint")}</p>
      <p className="mt-6 text-4xl font-extrabold text-center" data-testid="parent-gate-question">{q.a} + {q.b} = ?</p>
      <input inputMode="numeric" pattern="[0-9]*" value={value} onChange={(e) => setValue(e.target.value.replace(/\D/g, ""))}
        data-testid="parental-pin-input" aria-label={t("parents.answer")}
        className="mt-5 w-full rounded-full border-4 border-[#38B6FF]/30 bg-white px-6 py-4 text-center text-3xl font-bold outline-none focus:border-[#38B6FF]" />
      <button type="submit" data-testid="parent-gate-submit" className="btn-3d mt-6 w-full" style={{ "--c": "#4CC417" }}>{t("parents.enter")}</button>
    </form>
  );
};

export default function Parents() {
  const [open, setOpen] = useState(() => sessionStorage.getItem("mizubini_parent_ok") === "1");
  const pass = () => { sessionStorage.setItem("mizubini_parent_ok", "1"); setOpen(true); };
  const { found, total, reset } = useStars();
  const doReset = () => { reset(); toast.success(t("parents.resetDone")); };

  if (!open) return <Layout back="/"><Gate onPass={pass} /></Layout>;
  return (
    <Layout back="/">
      <h1 className="text-4xl sm:text-5xl font-extrabold text-white drop-shadow-[0_3px_0_rgba(30,42,90,0.35)]">{t("nav.parents")}</h1>
      <section className="cloud-card mt-8 p-6 sm:p-8" data-testid="parents-stars-section">
        <h2 className="text-2xl font-extrabold">{t("stars.skyTitle")}</h2>
        <p className="mt-2" data-testid="parents-stars-count">{t("parents.starsInfo", { n: found.length, total })}</p>
        <p className="mt-1 text-sm opacity-70">{t("parents.privacy")}</p>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <button type="button" data-testid="reset-stars-btn" className="btn-3d mt-5" style={{ "--c": "#F0303A" }}>
              <RotateCcw className="w-6 h-6" strokeWidth={2.5} /> {t("parents.reset")}
            </button>
          </AlertDialogTrigger>
          <AlertDialogContent className="rounded-[28px]">
            <AlertDialogHeader>
              <AlertDialogTitle>{t("parents.resetConfirmTitle")}</AlertDialogTitle>
              <AlertDialogDescription>{t("parents.resetConfirmText")}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-testid="reset-stars-cancel" className="rounded-full">{t("parents.cancel")}</AlertDialogCancel>
              <AlertDialogAction data-testid="reset-stars-confirm" onClick={doReset} className="rounded-full bg-[#F0303A] hover:bg-[#d6222c]">{t("parents.reset")}</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </section>
      <PacksShop />
      <NewsletterForm />
      <ContactForm />
    </Layout>
  );
}
